import {
    Box,
    TextField,
    Button,
    Typography,
    InputAdornment,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import NumbersIcon from "@mui/icons-material/Numbers";
import SmartphoneIcon from "@mui/icons-material/Smartphone";

import { useEffect, useState } from "react";
import { motion } from "motion/react";

import apiRc from "../../axios/axios";
import CanvaFirmaContrato from "./CanvaFirmaContrato";
import Swal from "sweetalert2";
import LoadingSpinner from "../Spinner";
import { useLocation, useNavigate } from "react-router-dom";

import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc =
    `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const FirmarContrato = () => {

    const [showPassword, setShowPassword] = useState(false);

    const [folio, setFolio] = useState("");
    const [ultimosDigitos, setUltimosDigitos] = useState("");

    const [contratoValidado, setContratoValidado] = useState(false);
    const [comprobando, setComprobando] = useState(false);

    const [error, setError] = useState("");
    const [errorFirma, setErrorFirma] = useState("");
    const [mensajeExito, setMensajeExito] = useState("");
    const [mensajeExitoFirma, setMensajeExitoFirma] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    const [paso, setPaso] = useState("comprobar");

    // =========================================================
    // REVISIÓN DEL CONTRATO PDF
    // =========================================================

    const [mostrarContrato, setMostrarContrato] = useState(false);
    const [pdfContrato, setPdfContrato] = useState(null);
    const [numPaginas, setNumPaginas] = useState(0);

    const [llegoAlFinal, setLlegoAlFinal] = useState(false);
    const [aceptoContrato, setAceptoContrato] = useState(false);

    const [cargandoPDF, setCargandoPDF] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const { folioContrato, ultimos4Cel } = location.state || {};


    // =========================================================
    // VALIDAR INFORMACIÓN RECIBIDA
    // =========================================================

    useEffect(() => {

        if (!folioContrato || ultimos4Cel == null) {

            navigate("/home-clientes", {
                replace: true
            });

            return;
        }

        setFolio(folioContrato);
        setUltimosDigitos(String(ultimos4Cel));

    }, [folioContrato, ultimos4Cel, navigate]);


    // =========================================================
    // REGRESAR A HOME
    // =========================================================

    const regresarHome = () => {

        navigate("/home-clientes", {
            replace: true
        });

    };


    // =========================================================
    // COMPROBAR CONTRATO
    // =========================================================

    const comprobarContrato = async () => {

        setError("");
        setMensajeExito("");

        if (!folio.trim()) {

            setError("Ingresa el folio del contrato");

            return;
        }

        if (ultimosDigitos.length !== 4) {

            setError("Ingresa los últimos 4 dígitos");

            return;
        }

        try {

            setComprobando(true);

            const jComprobar = {
                folio,
                ultimosDigitos,
            };

            await apiRc.post(
                "/ahorrador/comprobar-contrato-firma",
                jComprobar,
                {
                    headers: {
                        Accept: "application/x-www-form-urlencoded",
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            );

            // =================================================
            // CONTRATO VÁLIDO
            // =================================================

            setContratoValidado(true);

            setMensajeExito(
                "Contrato comprobado correctamente. Ya puedes continuar con la firma."
            );

        } catch (error) {

            console.error(error);

            let msg_error = "";

            if (error.response) {

                if (error.response.data?.mensaje) {

                    msg_error = error.response.data.mensaje;

                } else {

                    msg_error =
                        "No fue posible comprobar el contrato. Intenta nuevamente.";
                }

            } else {

                msg_error =
                    "No hay respuesta por parte del servidor!";
            }

            setError(msg_error);

        } finally {

            setComprobando(false);

        }
    };


    const consultarContratoPDF = async () => {

        setError("");
        setCargandoPDF(true);

        try {

            const token = sessionStorage.getItem("token");
        
            const { data } = await apiRc(`/obtener-contrato-pdf/${btoa(Number(folio))}`, {
                headers: {
                    'Accept': 'application/x-www-form-urlencoded',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': `Bearer ${token}`
                }
            });

            const base64PDF = data.b64html;

            const byteCharacters = atob(base64PDF);

            const byteNumbers = new Array(
                byteCharacters.length
            );

            for (
                let i = 0;
                i < byteCharacters.length;
                i++
            ) {
                byteNumbers[i] =
                    byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(
                byteNumbers
            );

            const blob = new Blob(
                [byteArray],
                {
                    type: "application/pdf"
                }
            );

            const url = URL.createObjectURL(blob);

            setPdfContrato(url);

            setMostrarContrato(true);

            setLlegoAlFinal(false);
            setAceptoContrato(false);

        } catch (error) {

            console.error(error);

            let msg_error = "";

            if (error.response) {

                if (error.response.data?.mensaje) {

                    msg_error =
                        error.response.data.mensaje;

                } else {

                    msg_error =
                        "No fue posible consultar el contrato. Intenta nuevamente.";
                }

            } else {

                msg_error =
                    "No hay respuesta por parte del servidor!";
            }

            setError(msg_error);

        } finally {

            setCargandoPDF(false);
        }
    };


    // =========================================================
    // CERRAR PDF
    // =========================================================

    const cerrarContratoPDF = () => {

        if (pdfContrato) {

            URL.revokeObjectURL(pdfContrato);

        }

        setPdfContrato(null);
        setMostrarContrato(false);

        setNumPaginas(0);
        setLlegoAlFinal(false);
        setAceptoContrato(false);
    };


    // =========================================================
    // PDF CARGADO
    // =========================================================

    const contratoCargado = ({
        numPages
    }) => {

        setNumPaginas(numPages);

    };


    // =========================================================
    // DETECTAR SI LLEGÓ AL FINAL
    // =========================================================

    const detectarFinalPDF = (event) => {

        const elemento =
            event.currentTarget;

        const estaAlFinal =
            elemento.scrollHeight -
            elemento.scrollTop -
            elemento.clientHeight <= 10;

        if (estaAlFinal) {

            setLlegoAlFinal(true);

        }
    };


    // =========================================================
    // CONTINUAR A FIRMA
    // =========================================================

    const continuarAFirma = () => {

        if (!llegoAlFinal) {
            return;
        }

        if (!aceptoContrato) {
            return;
        }

        cerrarContratoPDF();

        setErrorFirma("");
        setMensajeExitoFirma("");

        setPaso("firma");
    };

    return (

        <Box
            sx={{
                position: "fixed",
                inset: 0,

                width: "100vw",
                height: "100vh",

                backgroundImage: `
                    linear-gradient(
                        rgba(0,0,0,.45),
                        rgba(0,0,0,.45)
                    ),
                    url('/img/loginfirma.png')
                `,

                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "cover",

                overflowY: "auto",
                overflowX: "hidden",

                boxSizing: "border-box",

                px: {
                    xs: 1.5,
                    sm: 2,
                    md: 3,
                },

                pt: {
                    xs: 2,
                    sm: 3,
                    md: 4,
                },

                pb: {
                    xs: 5,
                    sm: 6,
                    md: 8,
                },
            }}
        >

            {/* =====================================================
                LOADING
            ===================================================== */}

            {isLoading && <LoadingSpinner />}


            {/* =====================================================
                CONTENEDOR RESPONSIVE
            ===================================================== */}

            <Box
                sx={{
                    width: "100%",

                    maxWidth: {
                        xs: "100%",
                        sm: "75%",
                        md: "650px",
                    },

                    ml: {
                        xs: 0,
                        sm: "auto",
                        md: "auto",
                    },

                    mr: {
                        xs: 0,
                        sm: "8%",
                        md: "22%",
                    },
                }}
            >

                {/* =================================================
                    BOTÓN REGRESAR A HOME
                ================================================= */}

                <motion.div
                    initial={{
                        opacity: 0,
                        x: -20,
                    }}

                    animate={{
                        opacity: 1,
                        x: 0,
                    }}

                    transition={{
                        duration: 0.5,
                        delay: 0.15,
                        ease: "easeOut",
                    }}
                >

                    <Box
                        sx={{
                            display: "flex",

                            justifyContent: {
                                xs: "center",
                                sm: "flex-start",
                            },

                            mb: {
                                xs: 1.5,
                                sm: 2,
                            },
                        }}
                    >

                        <Button
                            component={motion.button}

                            whileHover={{
                                scale: 1.04,
                                x: -2,
                            }}

                            whileTap={{
                                scale: 0.96,
                            }}

                            onClick={regresarHome}

                            startIcon={
                                <HomeOutlinedIcon />
                            }

                            variant="outlined"

                            sx={{
                                borderRadius: "10px",

                                textTransform: "none",

                                fontWeight: 600,

                                fontSize: {
                                    xs: "13px",
                                    sm: "14px",
                                },

                                color: "#ffffff",

                                borderColor:
                                    "rgba(255,255,255,.65)",

                                backgroundColor:
                                    "rgba(255,255,255,.12)",

                                backdropFilter: "blur(8px)",

                                px: {
                                    xs: 1.8,
                                    sm: 2.2,
                                },

                                py: {
                                    xs: 0.8,
                                    sm: 1,
                                },

                                minHeight: {
                                    xs: "40px",
                                    sm: "42px",
                                },

                                "& .MuiButton-startIcon": {
                                    marginRight: {
                                        xs: 0.5,
                                        sm: 1,
                                    },
                                },

                                "&:hover": {
                                    borderColor: "#ffffff",

                                    backgroundColor:
                                        "rgba(255,255,255,.20)",
                                },
                            }}
                        >

                            Regresar a Home

                        </Button>

                    </Box>

                </motion.div>


                {/* =================================================
                    ANIMACIÓN DEL CARD
                ================================================= */}

                <motion.div

                    initial={{
                        opacity: 0,
                        x: 100,
                        scale: 0.94,
                    }}

                    animate={{
                        opacity: 1,
                        x: 0,
                        scale: 1,
                    }}

                    transition={{
                        duration: 0.8,
                        ease: [0.22, 1, 0.36, 1],
                    }}

                    style={{
                        width: "100%",
                    }}
                >

                    {/* =================================================
                        CARD
                    ================================================= */}

                    <Box
                        sx={{
                            width: "100%",

                            background:
                                "rgba(255,255,255,0.96)",

                            borderRadius: {
                                xs: "18px",
                                sm: "24px",
                            },

                            border:
                                "1px solid rgba(255,255,255,0.8)",

                            boxShadow: `
                                0 25px 60px rgba(0,0,0,.25),
                                0 5px 20px rgba(0,0,0,.12)
                            `,

                            backdropFilter: "blur(10px)",

                            p: {
                                xs: 2.2,
                                sm: 4,
                                md: 5,
                            },

                            boxSizing: "border-box",

                            mb: {
                                xs: 4,
                                sm: 5,
                                md: 7,
                            },
                        }}
                    >

                        {/* =================================================
                            PASO 1 - COMPROBAR CONTRATO
                        ================================================= */}

                        {paso === "comprobar" && (
                            <>

                                {/* =============================================
                                    HEADER
                                ============================================= */}

                                <motion.div

                                    initial={{
                                        opacity: 0,
                                        y: -20,
                                    }}

                                    animate={{
                                        opacity: 1,
                                        y: 0,
                                    }}

                                    transition={{
                                        delay: 0.35,
                                        duration: 0.5,
                                        ease: "easeOut",
                                    }}
                                >

                                    <Box
                                        sx={{
                                            textAlign: "center",

                                            mb: {
                                                xs: 3,
                                                sm: 4,
                                            },
                                        }}
                                    >

                                        {/* =================================
                                            ICONO
                                        ================================= */}

                                        <motion.div

                                            initial={{
                                                opacity: 0,
                                                scale: 0.5,
                                                rotate: -10,
                                            }}

                                            animate={{
                                                opacity: 1,
                                                scale: 1,
                                                rotate: 0,
                                            }}

                                            transition={{
                                                delay: 0.45,
                                                duration: 0.55,
                                                type: "spring",
                                                stiffness: 180,
                                                damping: 12,
                                            }}
                                        >

                                            <Box
                                                sx={{
                                                    width: {
                                                        xs: 52,
                                                        sm: 58,
                                                    },

                                                    height: {
                                                        xs: 52,
                                                        sm: 58,
                                                    },

                                                    margin: {
                                                        xs: "0 auto 14px",
                                                        sm: "0 auto 18px",
                                                    },

                                                    borderRadius: {
                                                        xs: "14px",
                                                        sm: "16px",
                                                    },

                                                    display: "flex",

                                                    alignItems:
                                                        "center",

                                                    justifyContent:
                                                        "center",

                                                    background: `
                                                        linear-gradient(
                                                            135deg,
                                                            #29452f,
                                                            #3f6847
                                                        )
                                                    `,

                                                    color: "#fff",

                                                    boxShadow: `
                                                        0 8px 20px
                                                        rgba(41,69,47,.30)
                                                    `,
                                                }}
                                            >

                                                <AccountBalanceWalletOutlinedIcon
                                                    sx={{
                                                        fontSize: {
                                                            xs: 27,
                                                            sm: 30,
                                                        },
                                                    }}
                                                />

                                            </Box>

                                        </motion.div>


                                        {/* =================================
                                            TITULO
                                        ================================= */}

                                        <Typography
                                            sx={{
                                                fontSize: {
                                                    xs: "22px",
                                                    sm: "28px",
                                                    md: "30px",
                                                },

                                                fontWeight: 700,

                                                color: "#243b29",

                                                letterSpacing:
                                                    "-0.5px",

                                                lineHeight: 1.2,

                                                mb: 0.8,
                                            }}
                                        >
                                            Bienvenido a Ready Cash
                                        </Typography>


                                        <Typography
                                            sx={{
                                                fontSize: {
                                                    xs: "12.5px",
                                                    sm: "14px",
                                                },

                                                color: "#718076",

                                                lineHeight: 1.5,

                                                px: {
                                                    xs: 1,
                                                    sm: 0,
                                                },
                                            }}
                                        >
                                            Ingresa los datos de tu contrato
                                        </Typography>

                                    </Box>

                                </motion.div>


                                {/* =================================================
                                    FOLIO
                                ================================================= */}

                                <motion.div

                                    initial={{
                                        opacity: 0,
                                        x: -25,
                                    }}

                                    animate={{
                                        opacity: 1,
                                        x: 0,
                                    }}

                                    transition={{
                                        delay: 0.6,
                                        duration: 0.45,
                                        ease: "easeOut",
                                    }}
                                >

                                    <TextField
                                        fullWidth

                                        label="Folio Contrato"

                                        value={folio}

                                        disabled={
                                            contratoValidado
                                        }

                                        onChange={(e) => {

                                            setFolio(
                                                e.target.value
                                            );

                                            setError("");

                                        }}

                                        variant="outlined"

                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                >
                                                    <NumbersIcon
                                                        sx={{
                                                            color:
                                                                "#6b8170",
                                                        }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}

                                        sx={{
                                            mb: 2,

                                            "& .MuiOutlinedInput-root": {

                                                borderRadius:
                                                    "12px",

                                                backgroundColor:
                                                    "#f7f9f7",

                                                minHeight: {
                                                    xs: "52px",
                                                    sm: "56px",
                                                },

                                                transition:
                                                    "all .2s",

                                                "& fieldset": {
                                                    borderColor:
                                                        "#e0e7e1",
                                                },

                                                "&:hover fieldset": {
                                                    borderColor:
                                                        "#9db0a0",
                                                },

                                                "&.Mui-focused fieldset": {
                                                    borderColor:
                                                        "#29452f",

                                                    borderWidth:
                                                        "1.5px",
                                                },
                                            },

                                            "& .MuiInputLabel-root.Mui-focused":
                                            {
                                                color:
                                                    "#29452f",
                                            },
                                        }}
                                    />

                                </motion.div>


                                {/* =================================================
                                    ÚLTIMOS 4 DIGITOS
                                ================================================= */}

                                <motion.div

                                    initial={{
                                        opacity: 0,
                                        x: -25,
                                    }}

                                    animate={{
                                        opacity: 1,
                                        x: 0,
                                    }}

                                    transition={{
                                        delay: 0.75,
                                        duration: 0.45,
                                        ease: "easeOut",
                                    }}
                                >

                                    <TextField
                                        fullWidth

                                        label="Últimos 4 dígitos"

                                        value={ultimosDigitos}

                                        disabled={
                                            contratoValidado
                                        }

                                        onChange={(e) => {

                                            const value =
                                                e.target.value
                                                    .replace(/\D/g, "")
                                                    .slice(0, 4);

                                            setUltimosDigitos(
                                                value
                                            );

                                            setError("");

                                        }}

                                        type={
                                            showPassword
                                                ? "text"
                                                : "password"
                                        }

                                        variant="outlined"

                                        InputProps={{

                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                >

                                                    <SmartphoneIcon
                                                        sx={{
                                                            color:
                                                                "#6b8170",
                                                        }}
                                                    />

                                                </InputAdornment>
                                            ),

                                            endAdornment: (
                                                <InputAdornment
                                                    position="end"
                                                >

                                                    <IconButton

                                                        onClick={() =>
                                                            setShowPassword(
                                                                !showPassword
                                                            )
                                                        }

                                                        edge="end"

                                                        size="small"
                                                    >

                                                        {showPassword ? (

                                                            <VisibilityOffOutlinedIcon />

                                                        ) : (

                                                            <VisibilityOutlinedIcon />

                                                        )}

                                                    </IconButton>

                                                </InputAdornment>
                                            ),
                                        }}

                                        sx={{
                                            mb: 3,

                                            "& .MuiOutlinedInput-root": {

                                                borderRadius:
                                                    "12px",

                                                backgroundColor:
                                                    "#f7f9f7",

                                                minHeight: {
                                                    xs: "52px",
                                                    sm: "56px",
                                                },

                                                "& fieldset": {
                                                    borderColor:
                                                        "#e0e7e1",
                                                },

                                                "&:hover fieldset": {
                                                    borderColor:
                                                        "#9db0a0",
                                                },

                                                "&.Mui-focused fieldset": {
                                                    borderColor:
                                                        "#29452f",

                                                    borderWidth:
                                                        "1.5px",
                                                },
                                            },

                                            "& .MuiInputLabel-root.Mui-focused":
                                            {
                                                color:
                                                    "#29452f",
                                            },
                                        }}
                                    />

                                </motion.div>


                                {/* =================================================
                                    ERROR
                                ================================================= */}

                                {error && (

                                    <motion.div

                                        initial={{
                                            opacity: 0,
                                            y: -5,
                                        }}

                                        animate={{
                                            opacity: 1,
                                            y: 0,
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                backgroundColor:
                                                    "#fff4f4",

                                                border:
                                                    "1px solid #ffcdd2",

                                                borderRadius:
                                                    "10px",

                                                px: 2,
                                                py: 1.2,

                                                mb: 2,
                                            }}
                                        >

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#c62828",

                                                    fontSize:
                                                        "13px",

                                                    textAlign:
                                                        "center",

                                                    lineHeight: 1.5,
                                                }}
                                            >
                                                {error}
                                            </Typography>

                                        </Box>

                                    </motion.div>

                                )}


                                {/* =================================================
                                    MENSAJE ÉXITO
                                ================================================= */}

                                {mensajeExito && (

                                    <motion.div

                                        initial={{
                                            opacity: 0,
                                            y: -5,
                                        }}

                                        animate={{
                                            opacity: 1,
                                            y: 0,
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                backgroundColor:
                                                    "#f1f8f3",

                                                border:
                                                    "1px solid #b7d8bf",

                                                borderRadius:
                                                    "10px",

                                                px: 2,
                                                py: 1.2,

                                                mb: 2,
                                            }}
                                        >

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#2e6b3d",

                                                    fontSize:
                                                        "13px",

                                                    textAlign:
                                                        "center",

                                                    fontWeight: 600,

                                                    lineHeight: 1.5,
                                                }}
                                            >
                                                ✓ {mensajeExito}
                                            </Typography>

                                        </Box>

                                    </motion.div>

                                )}


                                {/* =================================================
                                    BOTÓN COMPROBAR / FIRMAR
                                ================================================= */}

                                <motion.div

                                    initial={{
                                        opacity: 0,
                                        y: 20,
                                    }}

                                    animate={{
                                        opacity: 1,
                                        y: 0,
                                    }}

                                    transition={{
                                        delay: 0.9,
                                        duration: 0.5,
                                        ease: "easeOut",
                                    }}
                                >

                                    <Button
                                        fullWidth

                                        variant="contained"

                                        disabled={
                                            comprobando ||
                                            cargandoPDF ||
                                            (
                                                !contratoValidado &&
                                                (
                                                    !folio ||
                                                    ultimosDigitos.length !== 4
                                                )
                                            )
                                        }

                                        onClick={() => {

                                            if (!contratoValidado) {

                                                comprobarContrato();

                                            } else {
                                                consultarContratoPDF();
                                                /*setErrorFirma("");
                                                setMensajeExitoFirma("");
                                                setPaso("firma");*/

                                            }
                                        }}

                                        sx={{
                                            height: {
                                                xs: "50px",
                                                sm: "52px",
                                            },

                                            borderRadius:
                                                "12px",

                                            textTransform:
                                                "none",

                                            fontSize: {
                                                xs: "14px",
                                                sm: "15px",
                                            },

                                            fontWeight: 700,

                                            background: `
                                                linear-gradient(
                                                    135deg,
                                                    #29452f,
                                                    #3f6847
                                                )
                                            `,

                                            boxShadow: `
                                                0 8px 18px
                                                rgba(41,69,47,.25)
                                            `,

                                            transition:
                                                "all .2s ease",

                                            "&:hover": {

                                                background: `
                                                    linear-gradient(
                                                        135deg,
                                                        #203924,
                                                        #34583d
                                                    )
                                                `,

                                                transform:
                                                    "translateY(-2px)",

                                            },

                                            "&:disabled": {
                                                background:
                                                    "#c8d1ca",
                                                color:
                                                    "#ffffff",
                                            },
                                        }}
                                    >

                                        {comprobando
                                            ? "Comprobando..."
                                            : cargandoPDF
                                                ? "Cargando contrato..."
                                                : contratoValidado
                                                    ? "Firmar"
                                                    : "Comprobar"
                                        }

                                    </Button>

                                </motion.div>

                            </>
                        )}


                        {/* =================================================
                            PASO 2 - FIRMA
                        ================================================= */}

                        {paso === "firma" && (

                            <>

                                <CanvaFirmaContrato

                                    folio={folio}

                                    onRegresar={() => {

                                        setPaso("comprobar");

                                    }}

                                    onConfirmar={async (firma) => {

                                        setErrorFirma("");
                                        setMensajeExitoFirma("");

                                        setIsLoading(true);

                                        try {

                                            // =================================
                                            // CONVERTIR BASE64 A BLOB
                                            // =================================

                                            const response =
                                                await fetch(firma);

                                            const blob =
                                                await response.blob();


                                            // =================================
                                            // CREAR FORMDATA
                                            // =================================

                                            const formData =
                                                new FormData();

                                            formData.append(
                                                "folio",
                                                folio
                                            );

                                            formData.append(
                                                "firma",
                                                blob,
                                                `firma_${folio}.png`
                                            );


                                            // =================================
                                            // ENVIAR A API
                                            // =================================

                                            const { data } =
                                                await apiRc.post(
                                                    "/ahorrador/firmar-contrato-online",
                                                    formData
                                                );


                                            setIsLoading(false);


                                            // =================================
                                            // MENSAJE DE ÉXITO
                                            // =================================

                                            Swal.fire({
                                                icon: "success",
                                                title: "¡Enhorabuena!",
                                                text: data.mensaje,
                                                confirmButtonText:
                                                    "Continuar",
                                                confirmButtonColor:
                                                    "#29452f",
                                            }).then(() => {

                                                window.location.href =
                                                    "/home-clientes";

                                            });

                                        } catch (error) {

                                            console.error(error);

                                            let msg_error = "";

                                            if (
                                                error.response
                                            ) {

                                                if (
                                                    error.response.data?.mensaje
                                                ) {

                                                    msg_error =
                                                        error.response.data.mensaje;

                                                } else {

                                                    msg_error =
                                                        "No fue posible firmar el contrato. Intenta nuevamente.";
                                                }

                                            } else {

                                                msg_error =
                                                    "No hay respuesta por parte del servidor!";
                                            }

                                            setIsLoading(false);

                                            setErrorFirma(
                                                msg_error
                                            );
                                        }
                                    }}

                                />


                                {/* =================================================
                                    ERROR FIRMA
                                ================================================= */}

                                {errorFirma && (

                                    <motion.div

                                        initial={{
                                            opacity: 0,
                                            y: -5,
                                        }}

                                        animate={{
                                            opacity: 1,
                                            y: 0,
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                backgroundColor:
                                                    "#fff4f4",

                                                border:
                                                    "1px solid #ffcdd2",

                                                borderRadius:
                                                    "10px",

                                                px: 2,
                                                py: 1.2,

                                                mt: 3,
                                                mb: 2,
                                            }}
                                        >

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#c62828",

                                                    fontSize:
                                                        "13px",

                                                    textAlign:
                                                        "center",

                                                    lineHeight: 1.5,
                                                }}
                                            >
                                                {errorFirma}
                                            </Typography>

                                        </Box>

                                    </motion.div>

                                )}


                                {/* =================================================
                                    MENSAJE ÉXITO FIRMA
                                ================================================= */}

                                {mensajeExitoFirma && (

                                    <motion.div

                                        initial={{
                                            opacity: 0,
                                            y: -5,
                                        }}

                                        animate={{
                                            opacity: 1,
                                            y: 0,
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                backgroundColor:
                                                    "#f1f8f3",

                                                border:
                                                    "1px solid #b7d8bf",

                                                borderRadius:
                                                    "10px",

                                                px: 2,
                                                py: 1.2,

                                                mt: 3,
                                                mb: 2,
                                            }}
                                        >

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#2e6b3d",

                                                    fontSize:
                                                        "13px",

                                                    textAlign:
                                                        "center",

                                                    fontWeight: 600,

                                                    lineHeight: 1.5,
                                                }}
                                            >
                                                ✓ {mensajeExitoFirma}
                                            </Typography>

                                        </Box>

                                    </motion.div>

                                )}

                            </>
                        )}

                    </Box>

                </motion.div>

            </Box>

            {/* =====================================================
                    MODAL - REVISAR CONTRATO
                ===================================================== */}

            <Dialog
                open={mostrarContrato}
                onClose={cerrarContratoPDF}
                fullWidth
                maxWidth="md"
                fullScreen={window.innerWidth <= 600}
                PaperProps={{
                    sx: {
                        height: {
                            xs: "100%",
                            sm: "90vh",
                        },

                        borderRadius: {
                            xs: 0,
                            sm: "18px",
                        },

                        overflow: "hidden",
                    },
                }}
            >

                {/* =============================================
                        TITULO
                    ============================================= */}

                <DialogTitle
                    sx={{
                        background:
                            "linear-gradient(135deg, #29452f, #3f6847)",

                        color: "#ffffff",

                        fontWeight: 700,

                        fontSize: {
                            xs: "18px",
                            sm: "20px",
                        },
                    }}
                >
                    Revisión del contrato
                </DialogTitle>


                {/* =============================================
                        PDF
                    ============================================= */}

                <DialogContent
                    sx={{
                        p: 0,
                        backgroundColor: "#525659",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        onScroll={detectarFinalPDF}
                        sx={{
                            width: "100%",
                            height: "100%",

                            overflowY: "auto",
                            overflowX: "hidden",

                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",

                            p: {
                                xs: 1,
                                sm: 2,
                            },

                            boxSizing: "border-box",
                        }}
                    >
                        {pdfContrato && (
                            <Document
                                file={pdfContrato}
                                onLoadSuccess={contratoCargado}

                                loading={
                                    <Typography
                                        sx={{
                                            color: "#ffffff",
                                            py: 5,
                                        }}
                                    >
                                        Cargando contrato...
                                    </Typography>
                                }

                                error={
                                    <Typography
                                        sx={{
                                            color: "#ffffff",
                                            py: 5,
                                        }}
                                    >
                                        No fue posible cargar el contrato.
                                    </Typography>
                                }
                            >
                                {Array.from(
                                    {
                                        length: numPaginas,
                                    },
                                    (_, index) => (
                                        <Box
                                            key={`pagina-${index + 1}`}
                                            sx={{
                                                mb: 2,

                                                backgroundColor: "#ffffff",

                                                boxShadow:
                                                    "0 3px 10px rgba(0,0,0,.25)",

                                                width: {
                                                    xs: "calc(100vw - 32px)",
                                                    sm: "750px",
                                                },

                                                maxWidth: "100%",

                                                overflow: "hidden",
                                            }}
                                        >
                                            <Page
                                                pageNumber={index + 1}

                                                width={
                                                    window.innerWidth < 600
                                                        ? window.innerWidth - 32
                                                        : 750
                                                }

                                                renderTextLayer
                                                renderAnnotationLayer
                                            />
                                        </Box>
                                    )
                                )}

                                <Box
                                    sx={{
                                        height: 30,
                                    }}
                                />
                            </Document>
                        )}
                    </Box>
                </DialogContent>


                {/* =============================================
                        PARTE INFERIOR
                    ============================================= */}

                <DialogActions
                    sx={{
                        display: "block",

                        p: {
                            xs: 1.5,
                            sm: 2,
                        },

                        backgroundColor:
                            "#ffffff",

                        borderTop:
                            "1px solid #e0e0e0",
                    }}
                >

                    {/* MENSAJE */}

                    {!llegoAlFinal && (

                        <Typography
                            sx={{
                                fontSize: "13px",

                                color: "#8a6d1d",

                                textAlign: "center",

                                mb: 1,
                            }}
                        >
                            Debes desplazarte hasta el final
                            del contrato para continuar.
                        </Typography>

                    )}


                    {llegoAlFinal && (

                        <Typography
                            sx={{
                                fontSize: "13px",

                                color: "#2e6b3d",

                                textAlign: "center",

                                fontWeight: 600,

                                mb: 1,
                            }}
                        >
                            Has llegado al final del contrato.
                        </Typography>

                    )}


                    {/* CHECKBOX */}

                    <FormControlLabel

                        control={

                            <Checkbox

                                checked={
                                    aceptoContrato
                                }

                                disabled={
                                    !llegoAlFinal
                                }

                                onChange={(event) => {

                                    setAceptoContrato(
                                        event.target.checked
                                    );

                                }}

                                sx={{
                                    color:
                                        "#29452f",

                                    "&.Mui-checked": {
                                        color:
                                            "#29452f",
                                    },
                                }}
                            />

                        }

                        label={
                            <Typography
                                sx={{
                                    fontSize: {
                                        xs: "12px",
                                        sm: "14px",
                                    },
                                }}
                            >
                                He leído y acepto los términos
                                y condiciones del contrato.
                            </Typography>
                        }

                        sx={{
                            width: "100%",
                            mb: 1,
                        }}
                    />


                    {/* BOTONES */}

                    <Box
                        sx={{
                            display: "flex",

                            justifyContent:
                                "flex-end",

                            gap: 1,
                        }}
                    >

                        <Button
                            onClick={
                                cerrarContratoPDF
                            }

                            variant="outlined"

                            sx={{
                                textTransform:
                                    "none",

                                borderRadius:
                                    "10px",

                                color:
                                    "#29452f",

                                borderColor:
                                    "#29452f",
                            }}
                        >
                            Cancelar
                        </Button>


                        <Button
                            onClick={
                                continuarAFirma
                            }

                            variant="contained"

                            disabled={
                                !llegoAlFinal ||
                                !aceptoContrato
                            }

                            sx={{
                                textTransform:
                                    "none",

                                borderRadius:
                                    "10px",

                                background:
                                    "linear-gradient(135deg, #29452f, #3f6847)",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg, #203924, #34583d)",
                                },
                            }}
                        >
                            Continuar con la firma
                        </Button>

                    </Box>

                </DialogActions>

            </Dialog>

        </Box>
    );
};

export default FirmarContrato;